module.exports = __webpack_public_path__ + "img/imprimax_white_logo.918713c4.png";